import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../Button'
import { ListItemIcons } from '../../../ListItem'

import DeleteIcon from '../../../../icons/delete.svg'

function EmailProfileWidgetCopiedToItemIcons({
  canRemove,
  isHovered,
  loading,
  onRemove,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <ListItemIcons {...restProps}>
      {isHovered && canRemove ? (
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: DeleteIcon }}
          disabled={loading}
          height={BUTTON_HEIGHT_32}
          tooltip={t(
            'EmailProfile.CopiedToWidgetItemRemoveCopyButtonTooltipKey'
          )}
          onClick={onRemove}
        />
      ) : null}
    </ListItemIcons>
  )
}

export default EmailProfileWidgetCopiedToItemIcons
